export default __webpack_public_path__ + "static/choose-templates-1-91d4aa127177733ba0f5b9b971ae028c.png";